var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReportReady(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#26AA94"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 20H7.5C7.0875 20 6.73438 19.8531 6.44063 19.5594C6.14688 19.2656 6 18.9125 6 18.5V6.5C6 6.0875 6.14688 5.73438 6.44063 5.44063C6.73438 5.14688 7.0875 5 7.5 5H13.5L18 9.5V18.5C18 18.9125 17.8531 19.2656 17.5594 19.5594C17.2656 19.8531 16.9125 20 16.5 20ZM12.75 10.25V6.5H7.5V18.5H16.5V10.25H12.75ZM7.5 10.25V6.5V18.5V10.25ZM9 13.25H15V11.75H9V13.25ZM9 15.5H15V14H9V15.5ZM9 17.75H12.75V16.25H9V17.75Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportReady);
export default __webpack_public_path__ + "static/media/reportReady.e1597e6c1fb2a942cc92e14c4a29abe8.svg";
export { ForwardRef as ReactComponent };